<template>
  <div class="back-ground">
    <div class="box">
      <Title en="Card" jp="カード情報" />
      <div class="wrapper">
        <input
          v-model="password"
          type="password"
          placeholder="Password"
          class="input"
        />
        <div class="remind">
          パスワードをお忘れの方は
          <router-link to="/password/reset" class="go-reminder">
            こちら
          </router-link>
        </div>
        <div class="confirm-wrapper">
          <button
            type="button"
            class="confirm"
            :class="{ disabled: locked || disabled }"
            :disabled="locked || disabled"
            @click="confirmPassword"
          >
            確認して続ける
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, inject } from "vue";
import { useRouter } from "vue-router";
import { authModuleInjectKey } from "@/composables/authentication";
import Title from "@/components/service/base/BaseTitle";
import { useState } from 'vue-gtag-next';

export default {
  name: "PasswordConfirm",
  components: {
    Title,
  },
  setup() {
    const router = useRouter();
    const auth = inject(authModuleInjectKey);
    const store = useState()
    const user = store.getters['auth/user']
    const { TOAST_STATUS, toast } = inject("useToast");

    const password = ref("");
    const locked = ref(false);
    const disabled = computed(() => password.value.length === 0);

    const confirmPassword = async () => {
      try {
        locked.value = true;
        await auth.reAuthenticate(user?.email, password.value);
        router.push("card");
      } catch {
        toast("パスワードが間違っています。", TOAST_STATUS.WARNING);
      } finally {
        locked.value = false;
      }
    };

    return {
      confirmPassword,
      password,
      locked,
      disabled,
    };
  },
};
</script>

<style scoped>
@media (min-width: 0px) {
  .wrapper {
    max-width: 100%;
    margin: 1.25rem 1.5625rem 0;
    padding-bottom: 12.5rem;
  }
  .input {
    width: 100%;
    height: 3.0625rem;
    border-style: none;
    border-radius: 0.4375rem;
    background-color: #e9e9e9;
  }
  input::placeholder {
    font-size: 0.875rem;
    font-weight: 500;
    color: #a8a8a8;
  }
  .remind {
    margin-top: 1.25rem;
    font-size: 0.75rem;
    text-align: center;
  }
  .go-reminder {
    padding-bottom: 0.0625rem;
    font-weight: 600;
    border-bottom-width: 0.0625rem;
    border-bottom-color: #000000;
  }
  .confirm {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 3.4375rem;
    margin-top: 1.5rem;
    border-radius: 0.4375rem;
    color: #ffffff;
    background-color: #202020;
  }
  .disabled {
    background-color: #acacac;
  }
}
@media (min-width: 640px) {
  .back-ground {
    padding-top: 4.875rem;
    padding-bottom: 7.5rem;
    background-color: #e9e9e9;
  }
  .box {
    width: 37.5rem;
    height: 28.125rem;
    margin: auto;
    background: #ffffff;
  }
  .wrapper {
    margin: 4.625rem 6.1875rem 0;
  }
  .remind {
    margin-top: 0.75rem;
    text-align: start;
  }
  .confirm-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  .confirm {
    width: 7.5rem;
    height: 2.1875rem;
    margin-top: 3.125rem;
    font-size: 0.75rem;
  }
}
</style>
